import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormControlElement} from 'Quoting/components/shared/QuoteFormControlElement';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {accidentFacilityCarePath} from './PropertyPaths/accidentFacilityCarePath';

export const InitialHospitalAdmission = () => {
  const {getQuoteFieldValue} = useQuoteField();
  const {selectedPlan, selectedProduct} = useSelector((state: ReducerState) => state.quoteForm);

  const propertyPaths = accidentFacilityCarePath(selectedPlan?.planIndex || 0, 0);

  const productCd = selectedProduct?.code ?? '';

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'initial-hospital-row-1'},
      items: [
        {
          key: propertyPaths.hospitalAdmissionDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue<number>(propertyPaths.hospitalAdmissionDetails.incurralPeriod)}
              id={propertyPaths.hospitalAdmissionDetails.incurralPeriod}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.hospitalAdmissionDetails.customizeBenefitAmount,
          hidden: true,
          element: (
            <QuoteFormControlElement
              controlType="checkbox"
              label="Customize Benefit Amount"
              checked={getQuoteFieldValue<boolean>(propertyPaths.hospitalAdmissionDetails.customizeBenefitAmount)}
              id={propertyPaths.hospitalAdmissionDetails.customizeBenefitAmount}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'initial-hospital-row-2'},
      items: [
        {
          key: propertyPaths.hospitalAdmissionDetails.benefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue<number>(propertyPaths.hospitalAdmissionDetails.benefitAmount)
              )}
              id={propertyPaths.hospitalAdmissionDetails.benefitAmount}
              disabled
              required
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.hospitalAdmissionDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              label="Number of Times Benefit is Payable per Time Period"
              searchKey={`${productCd}HospitalAdmissionBenefit.maxBenefitNumber`}
              value={getQuoteFieldValue<number>(propertyPaths.hospitalAdmissionDetails.maxBenefitNumber)}
              id={propertyPaths.hospitalAdmissionDetails.maxBenefitNumber}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'initial-hospital-row-3'},
      items: [
        {
          key: propertyPaths.hospitalAdmissionDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={`${productCd}HospitalAdmissionBenefit.timePeriodCd`}
              label="Time Period"
              value={getQuoteFieldValue<number>(propertyPaths.hospitalAdmissionDetails.timePeriodCd)}
              id={propertyPaths.hospitalAdmissionDetails.timePeriodCd}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};
